export const colors = {
  reprice: {
    backgroundGradient: 'rgba(249,112,12,0.2)',
    backgroundGradientStop: 'rgba(218,56,53,0.2)',
  },
};
